import { StringUtils } from '@/common/utils/StringUtils';

export const NumberCellRenderer = ({ value, colDef }) => {
  if (value == null) {
    return <span />;
  }

  let valueStr = StringUtils.formatNumber(value, colDef.decimalPrecision, colDef.minDecimalPrecision);

  return (
    <span cell-value={value} title={value} style={{ contentVisibility: 'auto', display: 'flex', justifyContent: 'flex-end' }}>
      {valueStr}
    </span>
  );
}